import 'components/_common-styles/index.scss';
import ParamStore from './logic/stores/param-store';
import ModelStore from './logic/stores/model-store';
import UiStateStore from './logic/stores/ui-state-store';
import UiActions from 'logic/ui-actions';
import PlatformDetection from 'infrastructure/platform-detection';
import CoreParamManager from './logic/params/core-param-manager';
import ParamManager from './logic/params/param-manager';
import FormType from './constants/form-type';
import FormVariant from './constants/form-variant';

if (!PlatformDetection.os.isSupported || !PlatformDetection.browser.isSupported) {
    throw new Error('Login component is not supported on this platform!!!');
}

let jwfLoginComponentId = 0,
    createInstance = () => {
        let componentId = jwfLoginComponentId++;

        return {
            // Latest supported public interface
            ApiV2: {
                // Initialize the component
                init: (params) => {
                    // Create models
                    ParamStore.registerComponent(componentId);
                    ModelStore.registerComponent(componentId);
                    UiStateStore.registerComponent(componentId);
                    // Handle global parameters
                    CoreParamManager.validateAndStore(params, componentId);
                    ParamManager.validateAndStore(params, componentId);
                },
                // Retrieve unique identifier of this instance
                getInstanceId: () => {
                    return componentId;
                },
                // Render login and/or registration form
                createForm: (placeHolder) => {
                    UiActions.createFormV2(placeHolder, componentId);
                },
                getFormType: () => {
                    return FormType;
                },
                getFormVariant: () => {
                    return FormVariant;
                }
            },

            // Previous deprecated public interface
            Api: {
                // Discontinue, no more providing Bubble experience
                initBubble: (placeHolder, params) => {
                    CoreParamManager.warnImplementer('Api.initBubble');
                    UiActions.initBubble(placeHolder, params, componentId);
                },
                // Discontinue, no more providing Bubble experience
                showBubble: (event) => {
                    CoreParamManager.warnImplementer('Api.showBubble');
                    UiActions.showBubble(event, componentId);
                },
                // Discontinue, no more providing Bubble experience
                hideBubble: () => {
                    CoreParamManager.warnImplementer('Api.hideBubble');
                    UiActions.hideBubble(componentId);
                },
                // Reborn in ApiV2
                createForm: (placeHolder, params) => {
                    CoreParamManager.warnImplementer('Api.createForm');
                    UiActions.createForm(placeHolder, params, componentId);
                },
                // Reborn in core layer
                getClsLoginUrl: () => {
                    CoreParamManager.warnImplementer('Api.getClsLoginUrl');
                    return UiActions.getClsLoginUrl(componentId);
                }
            },
            // Reborn in ApiV2
            FormType: FormType,
            // Reborn in ApiV2
            FormVariant: FormVariant,

            // Private interface
            _Api: {
                trackUiEvent: (trackingValue, cId) => {
                    UiActions.trackUiEvent(trackingValue, cId ? cId : componentId);
                },
                showProductInformation: (cId) => {
                    UiActions.showProductInformation(cId ? cId : componentId);
                },
                Links: {
                    termsLinkClicked: (cId) => {
                        UiActions.termsLinkClicked(cId ? cId : componentId);
                    },
                    privacyLinkClicked: (cId) => {
                        UiActions.privacyLinkClicked(cId ? cId : componentId);
                    },
                    federatedLoginLinkClicked: (clsLoginUrl, cId) => {
                        UiActions.federatedLoginLinkClicked(clsLoginUrl, cId ? cId : componentId);
                    },
                    existingLoginLinkClicked: (hasPassword, cId) => {
                        UiActions.existingLoginLinkClicked(hasPassword, cId ? cId : componentId);
                    }
                }
            }
        };
    };

let moduleExports = createInstance();
moduleExports.createInstance = createInstance;
module.exports = moduleExports;



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/